<template>
    <div id="dataStatistics">
		<div class="amountOfStatistical" >
			<h1  class="bgImg">订单数据</h1>
			<div class="scroll-div" id="amountOfStatistical" >
				<div class="">
					<div class="icon-arrow-left pointer" v-show="statisticScrollLeftShow" @click="scrollLeft('amountOfStatistical')">
						<i class="el-icon-arrow-left"></i>
					</div>
					<el-row class="el-row-order">
						<el-col :span="3">
							<div class="grid-content bg-purple">
								<div class="iconImg"><img src="../../assets/img/icon08.png" alt=""></div>
								<div class="conem">
									<div class="jisaeg">套餐总额</div>
									<div class="monery">{{money_format(dataStatistics.allPayOrderAmount/100, 2)}}</div>
								</div>
							</div>
						</el-col>
						<el-col :span="3">
							<div class="grid-content bg-purple">
								<div class="iconImg"><img src="../../assets/img/icon07.png" alt=""></div>
								<div class="conem">
									<div class="jisaeg">总订单</div>
									<div class="monery">{{dataStatistics.allPayOrderCount}}</div>
								</div>
							</div>
						</el-col>
						<el-col :span="3">
							<div class="grid-content bg-purple">
								<div class="iconImg"><img src="../../assets/img/icon02.png" alt=""></div>
								<div class="conem">
									<div class="jisaeg">上月订单</div>
									<div class="monery">{{dataStatistics.dayPayOrderAmount}}</div>
								</div>
							</div>
						</el-col>
						<el-col :span="3">
							<div class="grid-content bg-purple">
								<div class="iconImg"><img src="../../assets/img/icon07.png" alt=""></div>
								<div class="conem">
									<div class="jisaeg">本月订单</div>
									<div class="monery">{{dataStatistics.dayPayOrderCount}}</div>
								</div>
							</div>
						</el-col>
						<el-col :span="3">
							<div class="grid-content bg-purple">
								<div class="iconImg"><img src="../../assets/img/icon04.png" alt=""></div>
								<div class="conem">
									<div class="jisaeg">余额充值总额</div>
									<div class="monery">{{money_format(dataStatistics.yueTotal/100, 2)}}</div>
								</div>
							</div>
						</el-col>
						<el-col :span="3">
							<div class="grid-content bg-purple">
								<div class="iconImg"><img src="../../assets/img/icon05.png" alt=""></div>
								<div class="conem">
									<div class="jisaeg">上月充值</div>
									<div class="monery">{{money_format(dataStatistics.upyue/100, 2)}}</div>
								</div>
							</div>
						</el-col>
						<el-col :span="3">
							<div class="grid-content bg-purple">
								<div class="iconImg"><img src="../../assets/img/icon08.png" alt=""></div>
								<div class="conem">
									<div class="jisaeg">本月充值</div>
									<div class="monery">{{money_format(dataStatistics.nowyue/100, 2)}}</div>
								</div>
							</div>
						</el-col>
						<el-col :span="3">
							<div class="grid-content bg-purple">
								<div class="iconImg"><img src="../../assets/img/icon07.png" alt=""></div>
								<div class="conem">
									<div class="jisaeg">未使用余额</div>
									<div class="monery">{{money_format(dataStatistics.yueRemain/100,2)}}</div>
								</div>
							</div>
						</el-col>
					</el-row>
		
					<div class="icon-arrow-right pointer" v-show="statisticScrollRightShow" @click="scrollRight('amountOfStatistical')">
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
			</div>
		
		</div>
		<!--  余额充值统计  -->
		<div class="amountOfStatistical" style="border-radius: 16px;margin-top:10px;">
			<div class="scroll-div">
				<h1 class="bgImg" style="margin-bottom:14px"></h1>
				<div class="tag-defined" style="background: #fff;border-radius:10px">
					<div class="amountOfStatisticalItem" v-for="item in dataStatistics.list" :key="item.key">
						<!-- :style="{'margin-left':$store.state.style.sideShrink?'50px':'220px'}" -->
						<div :style="{'border-right':item.index!=='6' ? '1px solid #ccc':'none'}"  style="border-radius: 0px;">
							<div class='amountOfStatisticalItem-right'>
								<h2 style="color:#999; margin-top: 24px;">{{item.name}}</h2>				    			
								<h1 style="color:#333;">{{item.price}}</h1>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--  余额充值统计 end -->

		<div class="content">
			<h1 class="bgImg" style=""> 贡献榜</h1>
			<div class="item">
				<div  id="top5Order" ref="top5Order" style="height:300px;"></div>
				<div class="info"></div>
			</div>
		</div> 
	</div>
</template>
<script>
import {getDataStatistics, getSupplierFlux, getOrderTop5, dataStatistics} from '@/api/home.js'
import common from '@/utils/common.js'
var echarts = require('echarts');      // 引入 ECharts 主模块

export default {
    data(){
        return {
            supplierFlux: {
                ctccPoolName: '',
                amountData: '',            
                useData: '',
                remainData: ''
            },
            dataStatistics:{
                pre:{},
                cur:{}
            },
			
			
			balanceStatistics:[],
			cardStatistics:[],
			moreSupplierFlux: [],
			
			
			agent_path_names: [],
			qty: [],
			amount: [],
			top5Interval: null,

			
			//滚动数据
			scrollValOne: 0,
			statisticScrollLeftShow: false,
			statisticScrollRightShow: false,
			
			scrollValSecond: 0,
			statisticScrollLeftShowSecond: false,
			statisticScrollRightShowSecond: false,

			//广告点击统计数据
			linkClickStatistics:[],
        }
    },
    methods: {
		
		scrollLeft(element){
			let w = document.getElementById(element).clientWidth || document.getElementById(element).offsetWidth;
		
			if(this.scrollValOne >= document.getElementById(element).scrollWidth){
				this.scrollValOne = document.getElementById(element).scrollWidth - w - w/2;
			}
			else if(this.scrollValOne > 0){
				this.scrollValOne = this.scrollValOne - w;
			}
		
			if(this.scrollValOne <= 0){
				this.scrollValOne = 0;
				this.statisticScrollLeftShow = false;
			}
		
			document.getElementById(element).scrollTo({ 
				left: this.scrollValOne, 
				behavior: "smooth" 
			});
		
			this.statisticScrollRightShow = true;
		},
		
		scrollRight(element){
			let w = document.getElementById(element).clientWidth||document.getElementById(element).offsetWidth;
		
			if(document.getElementById(element).scrollWidth - this.scrollValOne <= w+w/2){
				this.scrollValOne = document.getElementById(element).scrollWidth;
			}else{
				this.scrollValOne = this.scrollValOne + w/2;
			}
		
			if(this.scrollValOne >= document.getElementById(element).scrollWidth){
				this.scrollValOne = document.getElementById(element).scrollWidth
				this.statisticScrollRightShow = false;
			}
			
			document.getElementById(element).scrollTo({ 
				left: this.scrollValOne, 
				behavior: "smooth" 
			});
			this.statisticScrollLeftShow = true;
		},
		
		
		scrollLeftSecond(element){
			let w = document.getElementById(element).clientWidth || document.getElementById(element).offsetWidth;
			if(this.scrollValSecond >= document.getElementById(element).scrollWidth){
				this.scrollValSecond = document.getElementById(element).scrollWidth - w - w/2;
			}
			else if(this.scrollValSecond > 0){
				this.scrollValSecond = this.scrollValSecond - w;
			}
			if(this.scrollValSecond <= 0){
				this.scrollValSecond = 0;
				this.statisticScrollLeftShowSecond = false;
			}

			document.getElementById(element).scrollTo({ 
				left: this.scrollValSecond, 
				behavior: "smooth" 
			});

			this.statisticScrollRightShowSecond = true;
		},

		scrollRightSecond(element){
			let w = document.getElementById(element).clientWidth||document.getElementById(element).offsetWidth;

			if(document.getElementById(element).scrollWidth - this.scrollValSecond <= w+w/2){
				this.scrollValSecond = document.getElementById(element).scrollWidth;
			}else{
				this.scrollValSecond = this.scrollValSecond + w/2;
			}
			

			if(this.scrollValSecond >= document.getElementById(element).scrollWidth){
				this.scrollValSecond = document.getElementById(element).scrollWidth
				this.statisticScrollRightShowSecond = false;
			}
			
			document.getElementById(element).scrollTo({ 
				left: this.scrollValSecond, 
				behavior: "smooth" 
			});
			this.statisticScrollLeftShowSecond = true;
		},
				
		
		drawMoreSupplierFlux(){
			let options = {
			    tooltip: {
			        trigger: 'item',
			        formatter: "{a} <br/>{b}: {c} ({d}%)"
			    },
			    legend: {
			        orient: 'vertical',
			        x: 'left',
			        data:['已用流量','剩余流量']
			    },
			    series: [
			        {
			            name:'流量使用情况',
			            type:'pie',
			            radius: ['70%', '40%'],
			            center: ['50%', '55%'],
			            avoidLabelOverlap: false,
			            label: {
			                normal: {
			                    show: false,
			                    position: 'center'
			                },
			                emphasis: {
			                    show: true,
			                    textStyle: {
			                        fontSize: '18',
			                    }
			                }
			            },
			            labelLine: {
			                normal: {
			                    position: 'outside',
			                    length: 40
			                }
			            },
			            color: ['#ff5643', '#25be3f'],
			            data:[
			                {value:0, name:'已用流量'},
			                {value:0, name:'剩余流量'}
			            ]
			        }
			    ]            
			}
			
			if(Array.isArray(this.moreSupplierFlux) && this.moreSupplierFlux.length > 0){
				for(let i=0; i<this.moreSupplierFlux.length; i++){
					let myChart = echarts.init(document.getElementById('flux' + i));
					options.series[0].data = [
						{value: this.moreSupplierFlux[i].useData, name:'已用流量'},
						{value: this.moreSupplierFlux[i].remainData, name:'剩余流量'}
					]
					myChart.setOption(options, true);
				}
			}
		},
		
		
		resize(){
			let w = document.getElementById('amountOfStatistical').clientWidth||document.getElementById('amountOfStatistical').offsetWidth;
			if(document.getElementById('amountOfStatistical').scrollWidth > w){
				if(this.scrollValOne >= document.getElementById('amountOfStatistical').scrollWidth){
					this.statisticScrollRightShow = false;
				}else{
					this.statisticScrollRightShow = true;
				}
				if(this.scrollValOne > 0){
					this.statisticScrollLeftShow = true;
				}				
			}else{
				this.statisticScrollLeftShow = false;
				this.statisticScrollRightShow = false;
			}
			
			let w2 = document.getElementById('more-flux').clientWidth||document.getElementById('more-flux').offsetWidth;
			if(document.getElementById('more-flux').scrollWidth > w2){
				if(this.scrollValSecond >= document.getElementById('more-flux').scrollWidth){
					this.statisticScrollRightShowSecond = false;
				}else{
					this.statisticScrollRightShowSecond = true;
				}
				
				if(this.scrollValSecond > 0){
					this.statisticScrollLeftShowSecond = true;
				}				
			}else{
				this.statisticScrollLeftShowSecond = false;
				this.statisticScrollRightShowSecond = false;
			}
			
			this.drawTop5();
		},
		drawTop5(){
			let top5OrderChart = echarts.init(this.$refs.top5Order);
			let top5OrderOption = {
				backgroundColor:'#ffffff',
					tooltip: {
					  trigger: 'axis',
					  axisPointer: { // 坐标轴指示器，坐标轴触发有效
						type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
					  }
					},
					grid: {
					  left: '2%',
					  right: '2%',
					  bottom: '5%',
					  top:'10%',
					  containLabel: true
					},
					legend: {
						data: ['本月充值总额'],
						right:10,
						top:0,
						textStyle: {
							color: "#2d2d2d"
						},
						itemWidth: 12,
						itemHeight: 10,
						// itemGap: 35
					},
					xAxis: {
						type: 'category',
						data: this.agent_path_names,
						axisLine: {
							lineStyle: {
								color: '#E7EBF7'
							}
						},
						axisLabel: {
						// interval: 0,
						// rotate: 40,
							textStyle: {
							  fontFamily: 'Microsoft YaHei',
							  color: '#2d2d2d'
							}
						},
					},
			
					yAxis: {
						type: 'value',
						axisLine: {
							show: false,
							lineStyle: {
							  color: '#2d2d2d'
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#E7EBF7'
							}
						},
						axisLabel: {}
					},

					series: [{
					  name: '本月销售金额',
					  type: 'bar',
					  barWidth: '4%',
					  itemStyle: {
							normal: {
								color: '#0078FF',
								barBorderRadius: 12,
							},
					  },
					  data: this.qty,
					},
					{
					  name: '昨日充值额',
					  type: 'bar',
					  barWidth: '4%',
					  itemStyle: {
							normal: {
								color: '#00E99D',
								barBorderRadius: 12,
							}
					  },
					  data: this.amount,
					}]
				  };

			top5OrderChart.resize();
			top5OrderChart.setOption(top5OrderOption, true);
			var app = {
				currentIndex: -1,
			};
			

			if(this.top5Interval){
				clearInterval(this.top5Interval)
				this.top5Interval = setInterval(function () {
					var dataLen = top5OrderOption.series[0].data.length;
						
					// 取消之前高亮的图形
					top5OrderChart.dispatchAction({
					  type: 'downplay',
					  seriesIndex: 0,
					  dataIndex: app.currentIndex
					});
					app.currentIndex = (app.currentIndex + 1) % dataLen;
					//console.log(app.currentIndex);
					// 高亮当前图形
					top5OrderChart.dispatchAction({
					  type: 'highlight',
					  seriesIndex: 0,
					  dataIndex: app.currentIndex,
					});
					// 显示 tooltip
					top5OrderChart.dispatchAction({
					  type: 'showTip',
					  seriesIndex: 0,
					  dataIndex: app.currentIndex
					});		
				}, 5000);
			}
			else{
				this.top5Interval = setInterval(function () {
					var dataLen = top5OrderOption.series[0].data.length;
						
					// 取消之前高亮的图形
					top5OrderChart.dispatchAction({
					  type: 'downplay',
					  seriesIndex: 0,
					  dataIndex: app.currentIndex
					});
					app.currentIndex = (app.currentIndex + 1) % dataLen;
					//console.log(app.currentIndex);
					// 高亮当前图形
					top5OrderChart.dispatchAction({
					  type: 'highlight',
					  seriesIndex: 0,
					  dataIndex: app.currentIndex,
					});
					// 显示 tooltip
					top5OrderChart.dispatchAction({
					  type: 'showTip',
					  seriesIndex: 0,
					  dataIndex: app.currentIndex
					});		
				}, 5000);
			}
			
			
		},
        
    },

    created() {
        // 加载统计数据
        dataStatistics().then(res=>{
            if(res.data.code == 200){
                let result = res.data.data; 
                this.dataStatistics = result;
                this.dataStatistics.pre = result.monthStatistics[0]!=null ? result.monthStatistics[0] : [];
                this.dataStatistics.cur = result.monthStatistics[1]!=null ? result.monthStatistics[1] : [];
            }
        });
		
		//各运行商流量池
		getSupplierFlux().then(res => {
		    if(res.data.code == 200){
		        let result = res.data.data;
		        this.moreSupplierFlux = result;
			}
		});
		
		getOrderTop5().then(res => {
			if(res.data.code == 200){
				let result = res.data.data;
				result.forEach(item => {
					this.agent_path_names.push(item.agent_path_names);
					this.qty.push(item.qty);
					this.amount.push(item.amount);
				});
				this.drawTop5();
			}
		});
		
		// //余额充值统计
		// common.sysRequest('balance/statistics', null, 'get').then(res=>{
		// 	if(res.data.code == 200){
		// 		this.balanceStatistics = res.data.data;
		// 		console.log(this.balanceStatistics)
		// 	}
		// });


		//卡片数量统计
		common.sysRequest('sim/statistics', null, 'get').then(res=>{
			if(res.data.code == 200){
				this.cardStatistics=res.data.data;
			}
		});
		


		//广告统计数据
		common.sysRequest('/haoka/admin/count', {}, 'post').then(res=>{
			this.linkClickStatistics = res.data.data;
		});
				
    },
	
	mounted(){
		this.resize();
		window.onresize = () => {
			return (() => {
				this.resize();
			})();
		};
		
		
	},
	
	updated() {
		this.drawMoreSupplierFlux();
		this.resize();
	},
	
	watch: {

	},
}
</script>  
<style lang="less" scoped>
.row-item{
	.el-col-6{
		padding: 10px;
		::v-deep .grid-content {
			background: #FFFFFF;
			border-radius: 8px;
			.title-left{
				background: #E6ECF6;
				border-top-left-radius: 8px;
				border-top-right-radius: 8px;
				color: #19213F;
				text-align:center;
				font-size:14px;
				height: 40px;
				font-weight: bold;
				line-height: 40px;
			}
			.row-flex{
				height:100px;
				.el-col-8{
					text-align: center;
				}
				.totleName{
					margin-top:20px;
					color: #636C88;
					font-size:14px;
					margin-bottom: 10px;
				}
				.totleNum{
					color: #19213F;
					font-size:16px;
				}
			}
		}
	}
}
.el-row-order{
	.el-col-3{
		padding: 10px;
		height: 110px;
		::v-deep .grid-content {
			background: #FFFFFF;
			border-radius: 8px;
			display: flex;
			height:100%;
			align-items: center;
			.iconImg{
				width:46px;
				height:46px;
				margin-left: 10px;
				img{
					width:46px;
					height:46px;
				}
			}
			.conem{
				margin-left: 10px;
				.jisaeg{
					color:#636C88;
					font-size:14px;
					margin-bottom:5px;
				}
				.monery{
					color: #19213F;
					font-size:20px;
				}
			}
		}
	}
}
::v-deep .el-tabs--border-card{
	background: #F3F5F9;
}
 h1.bgImg{
	// background: url(./../../assets/icon5.png) no-repeat left center;
	// padding-left:36px;
	font-size: 16px;
	color:#19213F;
	font-weight:bold;
	margin-bottom: 10px;
}
#dataStatistics { 
	
	.amountOfStatistical{
		/deep/ h1{
			font-size: 16px;
			line-height: 22px;
		}
		.scroll-div{
			padding:10px;
			// background: #fff;

			.tag-defined{
				min-height:110px;
				display: flex;
				justify-content: space-between;
	
	
				.amountOfStatisticalItem{
					flex: 1;
					padding-left: 80px;
					>div{
						box-sizing: border-box;
						max-width:300px;
						min-width:160px;
						height:110px;
						transition: .5s;
						border-radius:10px;
						color:#fff;
						h1{
							font-size:20px;
						}
	
						h2{
							font-size:15px;
						}
	
	
	
						.amountOfStatisticalItem-left{
							display:inline-block;
							width:5px;
							height:100%;
							float:left;
							border-radius: 4px 0 0 4px;
						}
	
						.amountOfStatisticalItem-right{
							display:inline-block;
							height:100%;
							margin-left:20px;
	
							h2{
								margin-top:15px;
							}
	
							h2, p{
								margin-bottom:10px;
							}
						}
	
					}
				}
	
				.amountOfStatisticalItem:last-child{
					padding-right: 0px;
				}
	
			}
	
		}



		.cardStatisticalItem{
			display: flex;
			flex-basis: 23%;
			box-sizing: border-box;
			height:120px;
			color: #424242;
			background: #fff;
			transition: .5s;	
			border-radius: 16px;
			.title-left{
				display: flex;
			    justify-content: center;
			    align-items: center;
			    flex-direction: column;
			    width: 65px;
			    background: #6196FC;
    			color: #fff;
				border-top-left-radius:16px;
				border-bottom-left-radius:16px;
			    h1{
				    width: 20px;
				    margin: 0 auto;
				    font-size: 16px;
				    line-height: 20px;
				    word-wrap: break-word;/*英文的时候需要加上这句，自动换行*/
				    text-align: center;
			    }
			}

			

			.content-right{
				display: flex;
			    justify-content: space-around;
			    align-items: center;
			    flex-direction: column;

				h1{
					width: 100%;
					font-size: 20px;

					span{
						display: inline-block;
					    text-align: center;
					    width: 90px;
						font-size: 14px;
						color:#999;
					}
				}
			}
		}
	
	}
	
	
	
	.icon-arrow-left, .icon-arrow-right{
		display: inline-block;
		width: 30px;
		line-height: 100px;
		vertical-align: top;
		font-size: 26px;
		text-align: center;
		transition: .5s;
		z-index: 100;
	}
	
	.icon-arrow-left:hover, .icon-arrow-right:hover{
		color: #409eff;
		transition: .3s;
	}
	
	.icon-arrow-left{
		position: absolute;
		left: 0;
		box-shadow: 10px 0px 10px #fff;
		background: #fff;
	}
	
	.icon-arrow-right{
		position: absolute;
		right: 0;
		box-shadow: -10px 0px 10px #fff;
		background: #fff;
	}
	.pointer{
		cursor: pointer;
	}
		
		
	
	
	
	
	.more-flux{
		overflow-y: hidden;
		height: 350px;
	
		.scroll-div{
			overflow-x: scroll;	
	
			.tag-defined{
				min-height:350px;
				display: flex;
				justify-content: space-between;
	
	
				.item {
				    width: 350px;
					height: 330px;
				    border: 1px solid #e4e7ed;
				    margin-right: 10px;
				    
				    h3 {
				        display: flex;
				        justify-content: space-between;
				        font-size: 16px;
				        padding: 10px;            
				        border-bottom: 1px solid #e4e7ed;
				        span {
				            padding-left: 6px;
				            border-left: 4px solid #409eff;
				        }
				    }
				    .info {
				        display: flex;
				        justify-content: space-around;
				        line-height: 2em;
				        div {
				            text-align: center;
				            span {
				                color: #409eff;
				            }
				        }
				    }
				    .ul_content{
				        margin-top: 4px;
				        margin-left: 10px;
				        font-size: 16px;
				        li{
				            padding-top: 4px;
				        }
				    }
				}
			}
		}
	}
  .content{
		margin-bottom: 10px;
		.item {
			margin: 0 10px;
			background: #fff;
			border-radius: 16px;
			h3 {
				display: flex;
				justify-content: space-between;
				font-size: 16px;
				padding: 10px;            
				border-bottom: 1px solid #e4e7ed;
				span {
					padding-left: 6px;
					border-left: 4px solid #409eff;
				}
			}
			.info {
				display: flex;
				justify-content: space-around;
				line-height: 2em;
				div {
					text-align: center;
					span {
						color: #409eff;
					}
				}
			}
			.ul_content{
				margin-top: 4px;
				margin-left: 10px;
				font-size: 16px;
				li{
						padding-top: 4px;
				}
			}
		}
	}
}
</style>